"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonContractInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const CommonContractInput = (props) => {
    const { autoselect, multiple, readOnly, disableClear, name, onChange, controller = "contracts", data = {}, withTokenType = false, } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const tokenType = (0, react_hook_form_1.useWatch)({ name: "tokenType" });
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: name, controller: controller, fetchData: {
            ...data,
            ...(withTokenType ? { contractType: [tokenType] } : {}),
            includeExternalContracts: true,
        }, onChange: onChange ? onChange(form) : undefined, autoSelect: autoselect, readOnly: readOnly, multiple: multiple, disableClear: disableClear }));
};
exports.CommonContractInput = CommonContractInput;
//# sourceMappingURL=index.js.map